import { type LucideIcon, TrendingDownIcon, TrendingUpIcon } from 'lucide-react'

import type { DeltaTrend } from './types'

export const DELTA_ICON: Record<DeltaTrend, LucideIcon> = {
  up: TrendingUpIcon,
  down: TrendingDownIcon,
}
